import { useState } from "react";
import { clearAuthStorage, fetchDataFromLocalStorage, navigateWithReload } from "../utils/helpers";
import routes from "../routes";
import { useMutation } from "@tanstack/react-query";
import { logout } from "../services/api/auth";
const useAuth = () => {
  const {
    isPending: isLogoutApiLoading,
    error: isLogoutApiError,
    mutateAsync: logoutMutation,
  } = useMutation({
    mutationFn: logout,
  });

  const user = fetchDataFromLocalStorage("user");
  const accessToken = fetchDataFromLocalStorage("accessToken");

  const [auth, setAuth] = useState({
    user: user,
    accessToken: accessToken,
  });

  const handleLogout = async () => {
    try {
      const refreshToken = fetchDataFromLocalStorage("refreshToken");
      await logoutMutation({
        refreshToken,
      });
      setAuth({ user: null });
      clearAuthStorage();
      navigateWithReload("/login");
    } catch (error) {}
  };

  const isAuthenticated = !!user && !!accessToken && user.isFirstLogin === false;

  const userModules = user?.role?.permissions?.map(
    (permission) => permission?.isRead && permission.module,
  );

  const userPermissions = user?.role?.permissions?.map((permission) => permission);

  const authRoutes = routes.filter((route) => {
    if (route.isFreelanceCompanyRoute) {
      return (
        route.isShow && user?.role?.role === "FREELANCER" && user?.company?.ownerId === user?.id
      );
    }
    return (!route.module || userModules?.includes(route.module)) && route.isShow;
  });

  const getPermissionForModule = (moduleName) => {
    const modulePermission = userPermissions?.find((perm) => perm.module === moduleName);

    return {
      hasReadAccess: modulePermission?.isRead ?? false,
      hasWriteAccess: modulePermission?.isWrite ?? false,
      hasUpdateAccess: modulePermission?.isUpdate ?? false,
      hasDeleteAccess: modulePermission?.isDelete ?? false,
    };
  };

  return {
    auth,
    authRole: user?.role?.role,
    logout: handleLogout,
    isAuthenticated,
    userModules,
    userPermissions,
    authRoutes,
    getPermissionForModule,
  };
};

export default useAuth;
